export const isImageMimeType = (mimeType: string) => {
  const imageMimeTypeRegex = new RegExp(/image\/(jpeg|png)/);
  return imageMimeTypeRegex.test(mimeType);
};